import { useAuth } from "@/contexts/AuthContext";
import { Navigate } from "react-router-dom";
import { SEOHead } from "@/components/SEOHead";
import { SMSSettingsManager } from "@/components/admin/SMSSettingsManager";

const SMSSettings = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div className="flex items-center justify-center min-h-screen">Loading...</div>;
  }

  if (!user) {
    return <Navigate to="/admin/login" replace />;
  }

  return (
    <>
      <SEOHead 
        title="SMS Settings"
        description="Manage SMS auto-reply settings and templates"
      />
      
      <SMSSettingsManager />
    </>
  );
};

export default SMSSettings;
